import { STUDIO_DATASETS_BUILDER_ROUTE } from "constants/links"
import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"

export function StudioButton({
  hash,
  dataset,
  disabled,
}: {
  hash?: string
  dataset?: string
  disabled?: boolean
}) {
  return (
    <LinkButton
      href={`${STUDIO_DATASETS_BUILDER_ROUTE}/new?dataset=${dataset}`}
      className="self-stretch !text-xs !h-auto !py-0.5 !px-2"
      size="small"
      variant="muted"
      disabled={disabled}
    >
      Open in studio
    </LinkButton>
  )
}
